/** @format */

import moment from "dayjs";
import { useHistory } from "../../router/useHistory";
import { connect } from "react-redux";

import {
  checkIsSubscriptionExpired,
  checkIsTrialCancelled,
  checkIsTrialExpired,
  checkIsTrialRunning,
  checkIsTrialSubscriptionRunning,
  checkUserInFreePlan,
} from "../../config/constants";
import { i18n } from "../../pages/private/languageSelector";

const Footer = ({ subscriptionData }) => {
  const history = useHistory();
  const trialEndedAt = subscriptionData?.trialEndedAt;
  const daysUntilTrialEnds = trialEndedAt
    ? moment(trialEndedAt).diff(moment(), "days")
    : null;

  const isTrialRunning = checkIsTrialRunning(subscriptionData);
  const isTrialSubscriptionRunning =
    checkIsTrialSubscriptionRunning(subscriptionData);
  const isTrialExpired = checkIsTrialExpired(subscriptionData);
  const userInFreePlan = checkUserInFreePlan(subscriptionData);
  const isSubscriptionExpired = checkIsSubscriptionExpired(subscriptionData);
  const isSubscrptionPaused =
    subscriptionData?.currentPlan?.status === "Paused";
  const isTrialCancelled = checkIsTrialCancelled(subscriptionData);

  const showFooter =
    !userInFreePlan && !isTrialSubscriptionRunning && !isTrialCancelled;

  // Footer "RETRY PAYMENT" — does NOT call the retry endpoint directly.
  // Instead it routes the user into the ChargeBillingDetails dialog on the
  // subscriptions page, which opens in "processing" state and auto-fires
  // the /retry-payment call (autoStartRetry). The user then sees the
  // Processing → Payment Successful / Payment Failed state machine — the
  // same consistent dialog flow as in-flow charges, per the Figma spec.
  //
  // Two signals so it works from any page:
  //   • sessionStorage `retryDialogIntent` — survives the cross-page
  //     navigation; the subscriptions page consumes it on mount.
  //   • `openRetryDialog` window event — handles the same-page case
  //     (footer is also rendered ON the subscriptions page, where the
  //     history.push below is a no-op and won't remount the page).
  const handleFooterRetryPayment = (e) => {
    e?.preventDefault();
    e?.stopPropagation();
    try {
      sessionStorage.setItem("retryDialogIntent", "1");
    } catch (_) {
      /* sessionStorage unavailable — same-page event path still works */
    }
    window.dispatchEvent(new CustomEvent("openRetryDialog"));
    history.push("/management/subscriptions");
  };

  // Footer SUBSCRIBE button — navigate to the subscriptions page where
  // the pricing-plan modal and Subscribe flow live. Previously had no
  // onClick handler, so clicks did nothing.
  const handleFooterSubscribe = (e) => {
    e?.preventDefault();
    e?.stopPropagation();
    history.push("/management/subscriptions");
  };

  return (
    <div>
      {showFooter && (
        <footer className="fixed bottom-0 w-full">
          <div
            className={`${
              isTrialExpired || isSubscriptionExpired
                ? "bg-colRedWhite"
                : isSubscrptionPaused
                ? "bg-white !border !border-colRed"
                : isTrialRunning
                ? "bg-colYellow"
                : ""
            }  flex items-center h-[59px] px-4`}
          >
            <div className="flex-grow text-center">
              {isTrialRunning && (
                <p className=" text-xs md:text-sm text-center">
                  {i18n("Subscriptions.TrialForUserManagementExpiresIn")}{" "}
                  {daysUntilTrialEnds} {i18n("Subscriptions.days")}
                </p>
              )}
              {isTrialExpired && (
                <p className=" text-xs md:text-sm text-center text-colRed">
                  {i18n("Subscriptions.TrialForUserManagementExpired")}
                </p>
              )}
              {isSubscriptionExpired && (
                <p className="text-xs md:text-sm text-center text-colRed">
                  {i18n(
                    "Subscriptions.UsersManagementSubscriptionExpiredSubscribeNow"
                  )}
                </p>
              )}
              {isSubscrptionPaused && (
                <p className="text-xs md:text-sm text-center text-colRed">
                  {i18n(
                    "Subscriptions.SubscriptionAutoRenewalFailedEnsurePaymentCardHasSufficientFunds"
                  )}
                </p>
              )}
            </div>
            {(subscriptionData?.currentPlan?.plan === "Free" ||
              subscriptionData?.currentPlan?.plan === "Trial" ||
              subscriptionData?.currentPlan?.status === "Expired") && (
              <button
                type="button"
                onClick={handleFooterSubscribe}
                className="text-xs md:text-sm font-bold text-backgroundLight cursor-pointer px-2 ml-auto border-none focus:border-none focus:outline-none"
              >
                {i18n("Subscriptions.SUBSCRIBE")}
              </button>
            )}
            {isSubscrptionPaused && (
              <button
                type="button"
                onClick={handleFooterRetryPayment}
                className="text-xs md:text-sm font-bold text-backgroundLight cursor-pointer px-2 ml-auto border-none focus:border-none focus:outline-none"
              >
                {i18n("Subscriptions.RETRYPAYMENT")}
              </button>
            )}
          </div>
        </footer>
      )}
    </div>
  );
};

const mapStateToProps = ({ subscription }) => ({
  subscriptionData: subscription.subscriptionData,
});

export default connect(mapStateToProps)(Footer);
